import { Typography } from '@/components/ui/Text';
import { IntakeTestimonialsSectionMobile } from './IntakeTestimonialsSectionMobile';
import TESTIMONIALS from './testimonials.data.json' with { type: 'json' };

import './IntakeTestimonialsSection.scss';

export const IntakeTestimonialsSection = () => (
  <div className='IntakeTestimonialsSection flex w-full justify-center'>
    <div className='flex max-w-[1800px] flex-col gap-[64px] py-[64px] md:mx-[90px]'>
      <div className='mx-auto my-[16px]'>
        <Typography
          className='IntakeTestimonialsSection__title'
          variant='h1-serif'
          as='h3'
        >
          Trusted by Those Who Expect the Best
        </Typography>
      </div>

      <div className='lg:hidden'>
        <IntakeTestimonialsSectionMobile />
      </div>

      <div className='max-lg:hidden'>
        <div className='IntakeTestimonialsSection__content IntakeTestimonialsSection__content--desktop mx-[30px] gap-[40px] lg:mx-[50px] xl:flex-row'>
          {TESTIMONIALS.map((testimonial, index) => (
            <div className='IntakeTestimonialsSection__item' key={index}>
              <div className='m-[30px] my-[50px] flex flex-col gap-[20px] md:m-[48px]'>
                <Typography variant='quote' as='p'>
                  {testimonial.quote}
                </Typography>

                <Typography variant='body' color='semidark'>
                  {testimonial.name}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);
